module.exports = __webpack_public_path__ + "static/media/mdi_access_time.21d0e0bb.svg";